// @ts-nocheck
import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import "./styles";
import reportWebVitals from "./reportWebVitals";

import { AksaraProvider } from "@aksara-ui/react";

import { Provider } from "react-redux";
import store from "./redux/store";
import ApiService from "service/Api";
import TokenService from "service/Token";
import { CookiesProvider } from 'react-cookie';

ApiService.init(process.env.REACT_APP_RUNTIME_API_SERVER);

if (TokenService.getIsAuthenticated()) {
  // ApiService.setHeader();
  ApiService.mount401Interceptor();
} else {
  // ApiService.removeHeader();
  ApiService.unmount401Interceptor();
}

ReactDOM.render(
  <React.Fragment>
    <Provider store={store}>
      <AksaraProvider>
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
          <App />
        </CookiesProvider>
      </AksaraProvider>
    </Provider>
  </React.Fragment>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
